import { forwardRef } from 'react';

import { Dialog } from '@/components/atoms';
import { DialogDescriptionProps } from '@/components/atoms/Dialog/DialogDescription';
import { cn } from '@/lib/utils/tailwind';

type ModalDescriptionProps = DialogDescriptionProps;

const ModalDescription = forwardRef<
  HTMLParagraphElement,
  ModalDescriptionProps
>(({ children, className, ...props }, ref) => (
  <Dialog.Description
    className={cn('text-muted-foreground text-sm', className)}
    ref={ref}
    {...props}
  >
    {children}
  </Dialog.Description>
));
ModalDescription.displayName = 'ModalDescription';

export { ModalDescription, type ModalDescriptionProps };
